import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { Id, toast } from "react-toastify";
import { Err } from "samuel-types";

// The InitialState For The Slice
const initialState: {
  attendances: Drivn.Attendance[] | [];
  attendanceRequests: Drivn.Attendance[] | [];
  loading: boolean;
  error?: Err;
  alreadyDispatched: boolean;
} = {
  attendances: [],
  attendanceRequests: [],
  loading: false,
  error: undefined,
  alreadyDispatched: false
};

// The Authentication Redux Slice
const attendanceSlice = createSlice({
  name: "attendance",
  initialState: initialState,
  reducers: {
    startAttendanceUpdate(state) {
      setAttendances([]);
      state.loading = true;
      return state;
    },
    attendanceError: (
      state,
      newValue: PayloadAction<[import("samuel-types").Err, Id | undefined]>
    ) => {
      if (newValue.payload[1]) {
        toast.update(newValue.payload[1], {
          render: newValue.payload[0].message,
          type: "error",
          isLoading: false,
          autoClose: 5000
        });
      } else {
        // Toast
        toast.error(newValue.payload[0].message);
      }

      // Setting The State
      return {
        ...state,
        loading: false,
        error: newValue.payload[0],
        alreadyDispatched: true
      };
    },
    setAttendances(
      state,
      newValue: PayloadAction<Drivn.Attendance[] | []>
    ) {
      state.attendances = newValue.payload;
      state.loading = false;
      state.error = undefined;
      state.alreadyDispatched = false;
      return state;
    },
    setAttendanceRequests(
      state,
      newValue: PayloadAction<Drivn.Attendance[] | []>
    ) {
      state.attendanceRequests = newValue.payload;
      state.loading = false;
      state.error = undefined;
      state.alreadyDispatched = false;
      return state;
    },
  }
});
// Exporting The Actions
export const {
  setAttendances,
  setAttendanceRequests,
  attendanceError,
  startAttendanceUpdate,
} = attendanceSlice.actions;

// Exporting The Slice
export default attendanceSlice;
